var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"container"}},[_c('amap',{attrs:{"zoom":15,"center":_vm.position}},[_c('amap-marker',{attrs:{"position":_vm.position,"label":_vm.label}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }